import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from 'src/app/core/config/configuration.service';
import { Gender } from '../orders/orders.proxy';

@Injectable()
export class UsersProxy {
    constructor(private http: HttpClient, private configurationService: ConfigurationService) {}

    async get(practiceId: string): Promise<UserSummaryDTO[]> {
        const url = this.configurationService.APIURL + '/api/users';
        let params = new HttpParams();
        params = params.append('practiceId', String(practiceId));
        return await this.http.get<UserSummaryDTO[]>(url, { params: params }).toPromise();
    }

    async userExists(email: string): Promise<boolean> {
        const url = this.configurationService.APIURL + '/api/users/any';
        let params = new HttpParams();
        params = params.append('email', email);
        return await this.http.get<boolean>(url, { params: params }).toPromise();
    }

    async create(practiceId: string, createUserDTO: CreateUserDTO): Promise<object> {
        const url = this.configurationService.APIURL + '/api/users';
        let params = new HttpParams();
        params = params.append('practiceId', String(practiceId));
        return await this.http.post(url, createUserDTO, { params: params }).toPromise();
    }

    async delete(practiceId: string, email: string): Promise<object> {
        const url = this.configurationService.APIURL + '/api/users';
        let params = new HttpParams();
        params = params.append('practiceId', String(practiceId));
        params = params.append('email', email);
        return await this.http.delete(url, { params: params }).toPromise();
    }

    async resetPassword(practiceId: string, email: string): Promise<object> {
        const url = this.configurationService.APIURL + '/api/users/resetPassword';
        let params = new HttpParams();
        params = params.append('practiceId', String(practiceId));
        params = params.append('email', email);
        return await this.http.post(url, {}, { params: params }).toPromise();
    }

    async markPracticeManager(practiceId: string, email: string, markPracticeManagerDTO: MarkPracticeManagerDTO): Promise<object> {
        const url = this.configurationService.APIURL + '/api/users/practiceManager';
        let params = new HttpParams();
        params = params.append('practiceId', String(practiceId));
        params = params.append('email', email);
        return await this.http.put(url, markPracticeManagerDTO, { params: params }).toPromise();
    }

    async markInvoiceReceiver(practiceId: string, email: string, markInvoiceReceiverDTO: MarkInvoiceReceiverDTO): Promise<object> {
        const url = this.configurationService.APIURL + '/api/users/invoiceReceiver';
        let params = new HttpParams();
        params = params.append('practiceId', String(practiceId));
        params = params.append('email', email);
        return await this.http.put(url, markInvoiceReceiverDTO, { params: params }).toPromise();
    }

    async markResultReceiver(practiceId: string, email: string, markResultReceiverDTO: MarkResultReceiverDTO): Promise<object> {
        const url = this.configurationService.APIURL + '/api/users/resultReceiver';
        let params = new HttpParams();
        params = params.append('practiceId', String(practiceId));
        params = params.append('email', email);
        return await this.http.put(url, markResultReceiverDTO, { params: params }).toPromise();
    }

    async markPurchaseOrderReceiver(practiceId: string, email: string, dto: MarkPurchaseOrderReceiverDTO): Promise<object> {
        const url = this.configurationService.APIURL + '/api/users/purchaseOrderReceiver';
        let params = new HttpParams();
        params = params.append('practiceId', String(practiceId));
        params = params.append('email', email);
        return await this.http.put(url, dto, { params: params }).toPromise();
    }

    async markMainContact(practiceId: string, email: string): Promise<object> {
        const url = this.configurationService.APIURL + '/api/users/mainContact';
        let params = new HttpParams();
        params = params.append('practiceId', String(practiceId));
        params = params.append('email', email);
        return await this.http.put(url, {}, { params: params }).toPromise();
    }
}

export interface CreateUserDTO {
    firstName: string;
    lastName: string;
    email: string;
    gender: Gender;
    isPracticeManager: boolean;
    isInvoiceReceiver: boolean;
    isResultReceiver: boolean;
    isPurchaseOrderReceiver: boolean;
}

export interface UserSummaryDTO {
    firstName: string;
    lastName: string;
    gender: Gender;
    email: string;
    lastLogin: Date;
    isMainContact: boolean;
    isPracticeManager: boolean;
    isInvoiceReceiver: boolean;
    isResultReceiver: boolean;
    isPurchaseOrderReceiver: boolean;
    canBeDeleted: boolean;
}

export interface MarkInvoiceReceiverDTO {
    isInvoiceReceiver: boolean;
}

export interface MarkResultReceiverDTO {
    isResultReceiver: boolean;
}

export interface MarkPurchaseOrderReceiverDTO {
    isPurchaseOrderReceiver: boolean;
}

export interface MarkPracticeManagerDTO {
    isPracticeManager: boolean;
}
